<div class="main-container">
  <div class="rr-container-white">
    <div class="">
      <h3 class="mb-1"><span class="px-2"><i class="fas fa-file-alt"></i></span> Well Files</h3>
    </div>
    <div *ngIf="selectedWell && hasWellFilesAccess">
      <div class="d-flex justify-content-center align-items-center pb-3" style="min-width: 100%;">
        <div *ngIf="isLoadingWellList" style="position: relative; bottom: -30px; left: 60px; z-index: 10;">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
          </div>
        </div>
        <p-dropdown [options]="wellOptions"
                    [(ngModel)]="selectedWellID"
                    [filter]="true"
                    [disabled]="isLoadingWellList"
                    [virtualScroll]="true"
                    itemSize="30"
                    scrollHeight="250px"
                    styleClass="wells-dropdown"
                    [resetFilterOnHide]="true"
                    placeholder="Select a well"
                    (onChange)="onWellSelect($event.value)">
          <ng-template pTemplate="selectedItem">
            <div *ngIf="selectedWell">
              <div><strong>{{selectedWell.wellName}}</strong></div>
            </div>
          </ng-template>
          <ng-template let-well pTemplate="item">
            <div>
              <div>{{well.wellName}}<span class="text-muted" *ngIf="well.apiNumber != ''"> - API#{{well.apiNumber}}</span></div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-start align-items-start pb-2" style="font-size: 0.95em;">
        <div class="d-flex flex-column pr-4 mr-4">
          <p class="mb-0 text-muted">API#</p>
          <p class="mb-2 well-list-item">{{selectedWell.apiNumber}}</p>
        </div>
        <div class="d-flex flex-column pr-4 mr-4">
          <p class="mb-0 text-muted">Field</p>
          <p class="mb-2 well-list-item">{{selectedWell.fieldName}}</p>
        </div>
        <div class="d-flex flex-column pr-4 mr-4">
          <p class="mb-0 text-muted">County/Parish</p>
          <p class="mb-2 well-list-item"><span><span *ngIf="selectedWell.regCounty">{{selectedWell.regCounty}}, </span>{{selectedWell.regState}}</span></p>
        </div>
      </div>
    </div>
  </div>
  <div class="rr-container-color" style="min-height: 95vh;">
    <div style="text-align: center; padding: 4em 1em" *ngIf="!hasWellFilesAccess">
      <div class="py-4">
        <img src="/assets/no-dashboard-img.svg" alt="No dashboards image" style="height: 125px;" />
      </div>
      <h5 class="pb-2"><strong>You do not currently have the necessary permissions to access the Well Files module.</strong></h5>
      <p>To request access to Well Files please contact the <a href="mailto:support@mi4.com">Mi4 Support Team</a> or your administrator.</p>
      <p class="text-muted"><em>If you were recently granted access and are still seeing this page, please log out and log back in again to refresh your permissions.</em></p>
    </div>
    <div *ngIf="hasWellFilesAccess">
      <app-add-well-file></app-add-well-file>
    </div>
  </div>
</div>
